// /* eslint-disable no-undef */
import jquery from 'jquery';
import 'modaal/dist/js/modaal';
import Macy from 'macy';


jquery(()=> {
  /****
   *
   * Image popup lightbox
   *
  ****/
  // eslint-disable-next-line no-undef
  jquery('.lightbox-gallery .lightbox-gallery__image img').modaal({
    type: 'image',
  });

  var macy = Macy({
    container: '.lightbox-gallery .lightbox-gallery__gallery',
    trueOrder: false,
    waitForImages: false,
    margin: 25,
    columns: 2,
    breakAt: {
      500: 1,
    },
  });

  macy.runOnImageLoad(function () {
    console.log('Every time an image loads I get fired');
    macy.recalculate(true);
  }, true);
});


